// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hSt2","title":"Info_title__z6tvx","links":"Info_links__1YXbx","link":"Info_link__YKHnT","logo":"Info_logo__2vsJW"};